export default {
    job: null,
    jobs: [],
    pagination: null,
	filterSet: false,
    currentStatusFilter: null,
	currentProjectManagerFilter: null
};
